import { NotFound } from 'shared/page/404';
import { ServerError } from 'shared/page/500';

export interface Props {
    statusCode: number;
}

export const ErrorPage = ({ statusCode }: Props) => {
    if (statusCode === 404) {
        return <NotFound troika />;
    }

    return <ServerError troika />;
};
